import * as React from "react";
const SvgFiRrEraser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23 21h-8.633l8.174-8.205a5.01 5.01 0 0 0 0-7.06L19.287 2.47A4.97 4.97 0 0 0 15.746 1a4.97 4.97 0 0 0-3.54 1.468L1.459 13.175a5.01 5.01 0 0 0 0 7.059l1.583 1.589A4.03 4.03 0 0 0 5.876 23H23a1 1 0 1 0 0-2M13.62 3.882A2.98 2.98 0 0 1 15.746 3c.804 0 1.558.313 2.125.882l3.254 3.265a3.01 3.01 0 0 1 0 4.236l-4.97 4.989-7.51-7.534zM5.876 21a1.99 1.99 0 0 1-1.417-.588l-1.584-1.589a3.005 3.005 0 0 1-.002-4.232L7.23 10.25l7.514 7.54-3.2 3.211z"
    />
  </svg>
);
export default SvgFiRrEraser;
